import { Checkbox } from 'antd';
import useAppFeature from 'src/app/useAppFeature';
import { useAppStore } from 'src/context/AppContext';
import { useAuthStore } from 'src/context/AuthContext';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { AppFeature } from 'src/types/ViewModel/AppFeature/AppFeature';
import { Container, Wrapper } from './FeaturesSelection.styles';

export const FeaturesSelectionComponent: React.FC = () => {
    const { appFeatureSettings, setAppFeatureSettings } = useAppStore();
    const { isFeatureEnabled } = useAppFeature();
    const { loggedInRole } = useAuthStore();

    const getAppFeature = (appFeatureId: AppFeatureEnum) => {
        return appFeatureSettings.find((a) => a.appFeatureId === appFeatureId);
    };

    const isCheckedFeature = (appFeatureId: AppFeatureEnum) => {
        const feature = getAppFeature(appFeatureId);
        if (feature?.isForcedEnabled) {
            return true;
        }
        if (feature?.isForcedDisabled) {
            return false;
        }
        return isFeatureEnabled({ featureEnum: appFeatureId, date: new Date() });
    };

    const toggleFeature = (appFeatureId: AppFeatureEnum) => {
        const appFeature = getAppFeature(appFeatureId);
        if (appFeature) {
            if (isFeatureEnabled({ featureEnum: appFeatureId, date: new Date() })) {
                appFeature.isForcedEnabled = false;
                appFeature.isForcedDisabled = true;
            } else {
                appFeature.isForcedEnabled = true;
                appFeature.isForcedDisabled = false;
            }
            localStorage.setItem('selectedFeatures', JSON.stringify(appFeatureSettings));
            setAppFeatureSettings([...appFeatureSettings]);
        }
    };

    const mapFeature = (feature: AppFeature) => {
        return (
            <Wrapper key={'appfeature-wrapper-' + feature.appFeatureId}>
                <ul key={'appfeature-' + feature.appFeatureId}>
                    <li key={'appfeature-li-' + feature.appFeatureId}>
                        <Checkbox
                            key={'appfeature-checkbox-' + feature.appFeatureId}
                            checked={isCheckedFeature(feature.appFeatureId as AppFeatureEnum)}
                            onClick={() => {
                                toggleFeature(feature.appFeatureId as AppFeatureEnum);
                            }}
                        ></Checkbox>
                        <span className="feature-name">{feature.featureName}</span>
                    </li>
                </ul>
            </Wrapper>
        );
    };

    return (
        <>
            {loggedInRole?.roleType === RoleTypeEnum.Admin && (
                <>
                    <br></br>
                    <h4>Selected features</h4>
                    <Container>{appFeatureSettings.map((feature) => mapFeature(feature))}</Container>
                </>
            )}
        </>
    );
};
export default FeaturesSelectionComponent;
